import { PRODUCTS_ACCESS } from "@/helpers/permissionsConstant";

export default [
  {
    path: "/admin/products",
    name: "admin-products",
    component: () => import("@/views/admin/product/ProductView.vue"),
    meta: {
      gate: PRODUCTS_ACCESS,
      requiresAuth: true,
      pageTitle: "Product",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Products",
          active: true,
          to: "",
        },
      ],
    },
  },
  {
    path: "/admin/product-attributes",
    name: "admin-attributes",
    component: () => import("@/views/admin/attribute/AttributeView.vue"),
    meta: {
      gate: PRODUCTS_ACCESS,
      requiresAuth: true,
      pageTitle: "Attributes",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Attributes",
          active: true,
          to: "",
        },
      ],
    },
  },
];